import Vue from 'vue'
import Router from 'vue-router'
import Home from "../views/Home"

import Goods from "../views/goods.vue"

import Login from "../components/Login"


import DownApp from "../views/DownApp.vue"

import About from "../views/About.vue"

import Teacher from "../views/Teacher.vue"

import TeacherDet from "../views/teacher/teacherDetails.vue"

import GoodDetails from "../views/good/GoodDetails.vue"

import OrderDetails from "../views/order/OrderDetails.vue"

import OrderList from "../views/order/OrderList.vue"

import Pay from "../views/order/Pay.vue"


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: "Home",
      component: Home,
      meta: { title: '首页' }
    },
    {
      path: '/home',
      name: "Home",
      component: Home,
    },
    {
      path: '/goods',
      name: "Goods",
      component: Goods,
    },
    {
      path: '/login',
      name: "Login",
      component: Login,
    },
    {
      path: '/downApp',
      name: "DownApp",
      component: DownApp,
    },
    {
      path: '/about',
      name: "About",
      component: About,
    },
    {
      path: '/teacher',
      name: "Teacher",
      component: Teacher,
    },
    {
      path: '/teacher/det',
      name: "TeacherDet",
      component: TeacherDet,
    },
    {
      path: '/good/det',
      name: "GoodDetails",
      component: GoodDetails,
    },
      {
      path: '/order/det',
      name: "OrderDetails",
      component: OrderDetails,
    },
    {
      path: '/order/pay',
      name: "Pay",
      component: Pay,
    },
     {
      path: '/order/list',
      name: "OrderList",
      component: OrderList,
    },
  ]
})
